import {Messages} from '../../constants';

const validation = {
  cep: {
    presence: {
      message: Messages.RequiredCepaddressValidationMessage,
      allowEmpty: false,
    },
  },
  logradouro: {
    presence: {
      message: Messages.RequiredHomeaddressValidationMessage,
      allowEmpty: false,
    },
  },
  numero: {
    presence: {
      message: Messages.RequiredNumberaddressValidationMessage,
      allowEmpty: false,
    },
  },
  bairro: {
    presence: {
      message: Messages.RequiredNeighborhoodaddressValidationMessage,
      allowEmpty: false,
    },
  },
  uf: {
    presence: {
      message: Messages.RequiredUfaddressValidationMessage,
      allowEmpty: false,
    },
  },
  cidade: {
    presence: {
      message: Messages.RequiredCityaddressValidationMessage,
      allowEmpty: false,
    },
  },
};

export default validation;
